import { useMemo } from 'react';
import { useNavigate } from 'react-router';
import particleIcon from '../../assets/icons/particle.png';
import TimeClockImage from '../../assets/icons/clock.png';
import catRunningRouteImage from '../../assets/images/new_main/main-cat-running-route.png';
import MulnyangImage from '../../assets/images/new_main/main-mul.png';
import PunchImage from '../../assets/images/new_main/main-punch.png';

const ROUTE_CARDS = [
  {
    path: '/punch',
    ariaLabel: '냥냥펀치 이동',
    eyebrow: '팡팡! 펀치와 같이 쌓이는 상금',
    title: '냥냥펀치',
    reward: '매번 150p',
    image: PunchImage,
    imageAlt: '냥냥펀치 아이콘',
    imageClassName: 'right-[25px] top-[15px] h-[80px] w-[85px]',
  },
  {
    path: '/time-nyang',
    ariaLabel: '타임냥 이동',
    eyebrow: '찰나의 감각, 멈춰! 단 3.23초에',
    title: '타임냥',
    reward: '매번 400p',
    image: TimeClockImage,
    imageAlt: '타임냥 아이콘',
    imageClassName: 'right-[23px] top-[13px] h-[88px] w-[88px]',
  },
  {
    path: '/mulnyang-bulnyang',
    ariaLabel: '물냥불냥 이동',
    eyebrow: '꼭 숨었지? 다른 하나를 찾아봐!',
    title: '물냥불냥',
    reward: '최대 1000p',
    image: MulnyangImage,
    imageAlt: '물냥불냥 아이콘',
    imageClassName: 'right-[18px] top-[5px] h-[98px] w-[104px]',
  },
  // {
  //   path: '/cat-running',
  //   ariaLabel: '캣러닝 이동',
  //   eyebrow: '무한 질주, 박진감 넘치는 달리기!',
  //   title: '캣러닝',
  //   reward: '무한포인트 가능!',
  //   image: catRunningRouteImage,
  //   imageAlt: '캣러닝 아이콘',
  //   imageClassName: 'right-[21px] top-[19px] h-16 w-20',
  // },
];

const getRandomRouteCard = () => ROUTE_CARDS[Math.floor(Math.random() * ROUTE_CARDS.length)];

function PlaygroundRouteCard() {
  const navigate = useNavigate();
  const card = useMemo(getRandomRouteCard, []);

  const handleNavigate = () => {
    navigate(card.path);
  };

  return (
    <div className="flex w-full">
      <div
        className="relative h-24 w-full cursor-pointer overflow-hidden rounded-[10px] bg-white shadow-[0px_5px_16px_0px_rgba(0,0,0,0.09)]"
        onClick={handleNavigate}
        role="button"
        tabIndex={0}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleNavigate();
          }
        }}
        aria-label={card.ariaLabel}
      >
        <div className="absolute right-2 top-[4px] h-[78.5px] w-[170px]">
          <img src={particleIcon} alt="" className="h-[78.5px] w-[170px]" />
        </div>

        <img src={card.image} alt={card.imageAlt} className={`absolute object-contain ${card.imageClassName}`} />

        <div className="absolute left-[22px] top-[18.5px] text-sm font-extrabold tracking-[-0.3px] text-[#8E8F99] font-['Pretendard']">
          {card.eyebrow}
        </div>

        <div className="absolute left-[22px] top-[42px] inline-flex items-center gap-2.5">
          <div className="inline-flex flex-col items-start justify-start">
            <div className="text-2xl font-extrabold tracking-[-0.3px] text-black font-['Pretendard']">{card.title}</div>
          </div>

          <div className="inline-flex h-9 items-center justify-center rounded-[20px] bg-background01 px-5 py-1.5">
            <div className="flex items-center justify-center">
              <span className="ml-1 text-sm font-extrabold text-primary-purple-01 font-['Pretendard']">{card.reward}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PlaygroundRouteCard;
